import api from './axios';

export const settingsApi = {
  getBlogEnabled: async (): Promise<boolean> => {
    const response = await api.get('/settings/blog-enabled');
    return response.data;
  },

  updateBlogEnabled: async (enabled: boolean): Promise<void> => {
    await api.put('/settings/blog-enabled', enabled, {
      headers: { 'Content-Type': 'application/json' }
    });
  },

  updateAutomaticTimeTracking: async (enabled: boolean): Promise<void> => {
    await api.put('/settings/automatic-time-tracking', enabled, {
      headers: { 'Content-Type': 'application/json' }
    });
  },
};
